import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useMingo } from '../context/MingoContext';
import { loadCookieConsent, saveCookieConsent } from '../lib/cookieConsentStorage';

function CookieConsentBanner() {
  const { t } = useMingo();
  const [open, setOpen] = useState(false);
  const [analytics, setAnalytics] = useState(false);
  const [marketing, setMarketing] = useState(false);

  useEffect(() => {
    const cur = loadCookieConsent();
    if (cur == null) setOpen(true);
    else {
      setAnalytics(!!cur.analytics);
      setMarketing(!!cur.marketing);
    }
  }, []);

  function acceptAll() {
    saveCookieConsent({ essential: true, analytics: true, marketing: true });
    setOpen(false);
  }

  function saveSelection() {
    saveCookieConsent({ essential: true, analytics, marketing });
    setOpen(false);
  }

  function rejectNonEssential() {
    saveCookieConsent({ essential: true, analytics: false, marketing: false });
    setOpen(false);
  }

  if (!open) return null;

  return (
    <div className="mingo-cookie-banner" role="dialog" aria-label={t('cookie.title')}>
      <div className="mingo-cookie-banner__inner">
        <p className="mingo-cookie-banner__text">{t('cookie.body')}</p>
        <p className="mingo-cookie-banner__sub">{t('cookie.gdpr')}</p>
        <div className="mingo-cookie-banner__opts">
          <label>
            <input type="checkbox" checked disabled readOnly />
            {t('cookie.essential')}
          </label>
          <label>
            <input type="checkbox" checked={analytics} onChange={(e) => setAnalytics(e.target.checked)} />
            {t('cookie.analytics')}
          </label>
          <label>
            <input type="checkbox" checked={marketing} onChange={(e) => setMarketing(e.target.checked)} />
            {t('cookie.marketing')}
          </label>
        </div>
        <div className="mingo-cookie-banner__actions">
          <button type="button" className="mingo-cookie-banner__btn" onClick={rejectNonEssential}>
            {t('cookie.rejectNonEssential')}
          </button>
          <button type="button" className="mingo-cookie-banner__btn mingo-cookie-banner__btn--sec" onClick={saveSelection}>
            {t('cookie.saveSelection')}
          </button>
          <button type="button" className="mingo-cookie-banner__btn mingo-cookie-banner__btn--primary" onClick={acceptAll}>
            {t('cookie.acceptAll')}
          </button>
        </div>
        <Link to="/privacy" className="mingo-cookie-banner__link" onClick={() => setOpen(false)}>
          {t('cookie.privacyLink')}
        </Link>
      </div>
    </div>
  );
}

export default CookieConsentBanner;
